import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Met a jour la balise <link rel="canonical"> a chaque changement de route.
 * Pointe toujours vers la version officielle (non-www) du site.
 */
const CANONICAL_HOST = "https://groupeaerhpolynesie.com";

export default function CanonicalUpdater() {
  const { pathname } = useLocation();

  useEffect(() => {
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    // Normalise le pathname (retire trailing slash sauf pour la racine)
    const cleanPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    canonical.setAttribute("href", `${CANONICAL_HOST}${cleanPath}`);
  }, [pathname]);

  return null;
}
